import React, { Component } from 'react';

/**
 * This is a static react port of the cdc template pinterest logo svg
 */
export default class PinterestLogo extends Component {

    render() {
        return (
            <svg width="25" height="24" viewBox="0 0 384 500" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M204 0.5C101.4 0.5 0 68.9 0 179.6C0 250 39.6 290 63.6 290C73.5 290 79.2 262.4 79.2 254.6C79.2 245.3 55.5 225.5 55.5 186.8C55.5 106.4 116.7 49.4 195.9 49.4C264 49.4 314.4 88.1 314.4 159.2C314.4 212.3 293.1 311.9 224.1 311.9C199.2 311.9 177.9 293.9 177.9 268.1C177.9 230.3 204.3 193.7 204.3 154.7C204.3 88.5 110.4 100.5 110.4 180.5C110.4 197.3 112.5 215.9 120 231.2C106.2 290.6 78 379.1 78 440.3C78 459.2 80.7 477.8 82.5 496.7C85.9 500.5 84.2 500.1 89.4 498.2C139.8 429.2 138 415.7 160.8 325.4C173.1 348.8 204.9 361.4 230.1 361.4C336.3 361.4 384 257.9 384 164.6C384 65.3 298.2 0.5 204 0.5Z" fill="white"/>
            </svg>
        );
    }

}
